(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["accordion"] && !window.DesignMode) return;
  try {
    

let accordionElems = document.querySelectorAll('.js-accordion-toggle');

[].forEach.call(accordionElems, function(el) {
	el.parentNode.classList.add('is--collapsed');
	el.addEventListener('click', function(e) {
		el.parentNode.classList.toggle('is--collapsed');
	});
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement"]) return;
  try {
    

	let announcementItems = document.querySelectorAll('.announcement-bar__text');
	let announcementCurrent = 0;
	let announcementTotal = announcementItems.length;

	announcementItems[0].classList.add('active');

	function rotateItems() {

		[].forEach.call(announcementItems, function(item, index) {
			if(index == announcementCurrent) {
				item.classList.add('active');
			} else {
				item.classList.remove('active');
			}
		});
	}
	if(announcementTotal > 1) {
		setInterval(function(){
			announcementCurrent++;
			if(announcementCurrent >= announcementTotal) {
				announcementCurrent = 0;
			}
			rotateItems();
		}, 3000);
	}

	rotateItems();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-survey"] && !window.DesignMode) return;
  try {
    

    function getCookie(name) {
	    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	    return v ? v[2] : null;
	}

    function clearCart(variant_id, qty) {
        jQuery.ajax({
            type: "POST",
            url: '/cart/clear.js',
            data: '',
            dataType: 'json',
            success: function() { 
                addItemToCart(variant_id, qty);
            },
            error: function(XMLHttpRequest, textStatus) {

            }
          });
          return false;
    }

    function addItemToCart(variant_id, qty) {
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                "id": variant_id,
                "quantity": qty
            },
            dataType: 'json',
            success: function(data) {
				document.cookie = 'survey_complete=true;';
                window.location.href = '/checkout'; 
            }
        });
    }

	(function(){
	
    	let discount = getCookie('discount_code');
		let complete = getCookie('survey_complete');

		if(complete != null) {
	
			let content = document.querySelector('[data-cf-form="bbtamL"]');
			let confirmation = '<h1 class="h--xl mb--1">Thank you, it looks like you have already completed the survey.</h1>';
			content.parentNode.innerHTML = confirmation;

		} else {
	
			if(discount != undefined) {
        		switch(discount) {
            		case promo:
                		clearCart(pid, 1);
                		break;
        		}
    	
    		}
		}
	})();


	
      
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-normal"] && !window.DesignMode) return;
  try {
    

(function() {

    let messages = document.querySelector('.rotating-messages'),
        messages_items = document.querySelectorAll('.rotating-messages > h4'),
        messages_next = 0;
    
    function updateMessages(cnt) {
        [].forEach.call(messages_items, function(item,index) {
            if(index == cnt) {
                messages_items[index].style.display = 'block';
            } else {
                messages_items[index].style.display = 'none';
            }
        })
        
        messages_next = cnt + 1;

        if(messages_next >= messages_items.length) {
            messages_next = 0;
        }
    }
    
    updateMessages(0);

    setInterval(function(){
        updateMessages(messages_next);
    }, 3000);
    
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-polariod"] && !window.DesignMode) return;
  try {
    

(function(){

    let polaroids = document.querySelectorAll('.polaroids-image');

        [].forEach.call(polaroids, function(item) {
            item.style.position = 'absolute';
            item.style.left = '50%';
        });
    
    function isInViewport(elem) {
        let bounding = elem.getBoundingClientRect(),
            bottom = window.innerHeight || document.documentElement.clientHeight;
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                bounding.bottom <= bottom
            );
    }

    window.addEventListener('scroll', function () {

        let scrollPos = window.pageYOffset || document.documentElement.scrollTop;

        [].forEach.call(polaroids, function(inview, index) {
            if (isInViewport(inview, index)) {
                inview.setAttribute('data-inview', 'true');
            }
        });

    }, false);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rotating"] && !window.DesignMode) return;
  try {
    

(function() {

    let messages = document.querySelector('.rotating-messages'),
        messages_items = document.querySelectorAll('.rotating-messages > h4'),
        messages_next = 0;

    function updateMessages(cnt) {
        [].forEach.call(messages_items, function(item,index) {
            if(index == cnt) {
                messages_items[index].style.display = 'block';
            } else {
                messages_items[index].style.display = 'none';
            }
        })
        
        messages_next = cnt + 1;

        if(messages_next >= messages_items.length) {
            messages_next = 0;
        }
    }
    
    updateMessages(0);

    setInterval(function(){
        updateMessages(messages_next);
    }, 3000);
    
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rotator-quotes"] && !window.DesignMode) return;
  try {
    

(function() {

    let rotatingQuotes = document.querySelectorAll('.rotating-quotes'),
        rotatingQuotesNext = 0;
    
    function updateRotatingQuote(cnt) {

        [].forEach.call(rotatingQuotes, function(item,index) {
            if(index == cnt) {
                rotatingQuotes[index].style.display = 'block';
            } else {
                rotatingQuotes[index].style.display = 'none';
            }
        })
        
        rotatingQuotesNext = cnt + 1;

        if(rotatingQuotesNext >= rotatingQuotes.length) {
            rotatingQuotesNext = 0;
        }
    }
    
    updateRotatingQuote(0);

    setInterval(function(){
        updateRotatingQuote(rotatingQuotesNext);
    }, 3000);
    
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-rotator"] && !window.DesignMode) return;
  try {
    

(function() {

    let messages = document.querySelector('.rotating-messages'),
        messages_items = document.querySelectorAll('.rotating-messages > h4'),
        messages_next = 0;
    
    function updateMessages(cnt) {
        [].forEach.call(messages_items, function(item,index) {
            if(index == cnt) {
                messages_items[index].style.display = 'block';
            } else {
                messages_items[index].style.display = 'none';
            }
        })
        
        messages_next = cnt + 1;

        if(messages_next >= messages_items.length) {
            messages_next = 0;
        }
    }
    
    updateMessages(0);

    setInterval(function(){
        updateMessages(messages_next);
    }, 3000);
    
})();


  } catch(e) { console.error(e); }
})();

})();
